module.exports = __webpack_public_path__ + "img/google-play.d2d7e3d3.png";